/** biome-ignore-all lint/style/useNamingConvention: <TODO: change config> */
import { Slide, type ToastContentProps, type ToastOptions, toast } from 'react-toastify';

import styles from './notification.module.css';

export const NOTIFICATION_TYPES = {
  ERROR: 'error',
  SUCCESS: 'success',
} as const;

interface NotificationMessageProps extends Partial<ToastContentProps> {
  message: string;
  requestId?: string;
  type: NotificationType;
}

type NotificationType = (typeof NOTIFICATION_TYPES)[keyof typeof NOTIFICATION_TYPES];

const NotificationMessage = ({ message, type, requestId }: NotificationMessageProps) => (
  <div className={`${styles.message} ${styles[type]}`}>
    <p className={styles.messageFirstLine}>{message}</p>
    {requestId && <p className={styles.messageAdditionalInfo}>Request ID: {requestId}</p>}
  </div>
);

export const showNotification = ({
  message,
  type,
  requestId,
  toastId,
}: {
  message: string;
  type: NotificationType;
  requestId?: string;
  toastId?: ToastOptions['toastId'];
}) => {
  toast(<NotificationMessage message={message} requestId={requestId} type={type} />, {
    autoClose: 4000,
    className: styles.notificationWrapper,
    closeButton: false,
    hideProgressBar: true,
    position: 'bottom-right',
    toastId,
    transition: Slide,
  });
};
